import { connect } from 'react-redux'
import dateformat from 'dateformat'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import WebBoard from '../components/WebBoard'
import * as constants from '../../../constants'
import { deepCopy, renjuBoardCardToStr } from '../../../lib'
import { webBoard as limit } from '../../../constants/Limit'

const mapStateToProps = (state, ownProps) => {
  const { mode, boardTitle, openNewBoardCnfDlg, openSaveCnfDlg, openChangeNameCnfDlg } = state.webBoard
  const { width } = state.window
  const { records, editingBoardId } = state.storeBoardCard
  const { user, isAuthStateChange } = state.authentication
  var bid, card, disabledNewBoard, disabledUpdate, disabledSave, disabledChangeName, record, cardTitle, cardSubheader, hasRecord, deleteKeys, currentBoard, recordBoard, tempBoard, isEdited
  
  record = records.find((rc) => rc.id === editingBoardId)
  if (record) {
    cardTitle = record.title && record.title !== '' ? record.title : ''
    cardSubheader =
      record.updateDatetime ? dateformat(record.updateDatetime, 'yyyy/m/d H:MM') :
      record.createDatetime ? dateformat(record.createDatetime, 'yyyy/m/d H:MM') : ''
  }
  else {
    cardTitle = ''
    cardSubheader = ''
  }
  hasRecord = Boolean(record)
  
  bid = state.renjuBoardCards.cards.findIndex((card) => card.type === constants.boardType.WEB_BOARD)
  card = bid >= 0 ? state.renjuBoardCards.cards[bid] : undefined

  isEdited = false
  deleteKeys = ['v', 'md', 'op']
  if (hasRecord && card) {
    currentBoard = renjuBoardCardToStr(card)
    recordBoard = renjuBoardCardToStr(record.boardContext)
    tempBoard = {
      ...deepCopy(currentBoard),
      ...deepCopy(recordBoard),
    }
    deleteKeys.forEach((key) => delete tempBoard[key])
    isEdited = (Object.keys(tempBoard).some((key) => currentBoard[key] !== recordBoard[key]))
  }
  else if (card) {
    currentBoard = renjuBoardCardToStr(card)
    deleteKeys.forEach((key) => delete currentBoard[key])
    isEdited = Object.keys(currentBoard).some((key) => currentBoard[key] !== undefined && currentBoard[key] !== '')
  }
  disabledNewBoard = !hasRecord && !isEdited
  disabledUpdate = !hasRecord || !isEdited
  disabledSave = records.length > limit.maxRecordLength
  disabledChangeName = !hasRecord

  return ({
    user,
    isAuthStateChange,
    bid,
    mode,
    editingBoardId,
    card,
    width,
    cardTitle,
    cardSubheader,
    boardTitle,
    openNewBoardCnfDlg,
    openSaveCnfDlg,
    openChangeNameCnfDlg,
    disabledNewBoard,
    disabledUpdate,
    disabledSave,
    disabledChangeName,
    hasRecord,
    isEdited,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      var urlProps = {}
      Object.keys(ownProps).forEach((key) => {
        if (key.match(/v|md|op|mv|pb|pw|tr|rc|an|mc|mk|tl|bp|wp|gr|pt|lv|or|sw|fn|fm|sk|moves/)) {
          urlProps[key] = ownProps[key]
        }
      })
      dispatch(actions.webBoard.init(constants.boardType.WEB_BOARD, { ...urlProps }))
    },
    webBoardMenuProps: {
      handleNewBoard: (isEdited) => () => {
        if (isEdited) {
          dispatch(actions.webBoard.confirmDialog.open('NewBoardCnfDlg'))
        }
        else {
          dispatch(actions.webBoard.refresh())
        }
      },
      handleSave: (cardTitle, card) => () => {
        if (cardTitle) {
          dispatch(actions.webBoard.confirmDialog.changedText('boardTitle', cardTitle))
        }
        else if (card.gameInfo && card.gameInfo.title) {
          dispatch(actions.webBoard.confirmDialog.changedText('boardTitle', card.gameInfo.title))
        }
        else {
          dispatch(actions.webBoard.confirmDialog.changedText('boardTitle', ''))
        }        
        dispatch(actions.webBoard.confirmDialog.open('SaveCnfDlg'))
      },
      handleUpdate: (id, card) => () => {
        dispatch(api.board.update(id, card))
      },
      handleChangeName: (cardTitle, card) => () => {
        if (cardTitle) {
          dispatch(actions.webBoard.confirmDialog.changedText('boardTitle', cardTitle))
        }
        else if (card.gameInfo && card.gameInfo.title) {
          dispatch(actions.webBoard.confirmDialog.changedText('boardTitle', card.gameInfo.title))
        }
        else {
          dispatch(actions.webBoard.confirmDialog.changedText('boardTitle', ''))
        }
        dispatch(actions.webBoard.confirmDialog.open('ChangeNameCnfDlg'))
      }
    },
    fileTitleCardProps: {
      handleClickMode: (mode) => () => {
        if (mode === constants.webBoardModeType.EDIT) {
          dispatch(actions.webBoard.fileTitleCard.changedMode(constants.webBoardModeType.FOLDER))
        }
        else if (mode === constants.webBoardModeType.FOLDER) {
          dispatch(actions.webBoard.fileTitleCard.changedMode(constants.webBoardModeType.EDIT))
        }
      }
    },
    newBoardCnfDlgProps: {
      handleOK: () => {
        dispatch(actions.webBoard.refresh())
        dispatch(actions.webBoard.confirmDialog.close('NewBoardCnfDlg'))
      },
      handleClose: () => {
        dispatch(actions.webBoard.confirmDialog.close('NewBoardCnfDlg'))
      }
    },
    saveCnfDlgProps: {
      handleChangeText: (name) => (event) => {
        dispatch(actions.webBoard.confirmDialog.changedText(name, event.target.value))
      },
      handleOK: (card, title) => () => {
        dispatch(api.board.add(card, title))
        dispatch(actions.webBoard.confirmDialog.close('SaveCnfDlg'))
      },
      handleClose: () => {
        dispatch(actions.webBoard.confirmDialog.close('SaveCnfDlg'))
      },
    },
    changeNameCnfDlgProps: {
      handleChangeText: (name) => (event) => {
        dispatch(actions.webBoard.confirmDialog.changedText(name, event.target.value))
      },
      handleOK: (id, title) => () => {
        dispatch(api.board.update(id, undefined, title))
        dispatch(actions.webBoard.confirmDialog.close('ChangeNameCnfDlg'))
      },
      handleClose: () => {
        dispatch(actions.webBoard.confirmDialog.close('ChangeNameCnfDlg'))
      },
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WebBoard)



// WEBPACK FOOTER //
// ./src/Pages/WebBoard/containers/WebBoard.js